import { format } from '@cobliteam/utils/date';

export const formatTimestamp = (timestampInMilliseconds: number) => {
  return format(timestampInMilliseconds, "dd/MM/yyyy 'às' HH:mm");
};
